import { keyBy } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RuntimeContext } from '../../../common/RuntimeContext';
import { getLearningAsset, getManyUserLearningAssets, postUserLearningAsset } from '../../shared/actions';
import LoadingIndicator from '../../shared/components/LoadingIndicator';

class AssetLink extends Component {
    static propTypes = {
        getManyUserLearningAssets: PropTypes.func,
        postUserLearningAsset: PropTypes.func,
        getLearningAsset: PropTypes.func,
        loggedInUser: PropTypes.object,
        userLearningAssetsByLearningAssetId: PropTypes.object,
        history: PropTypes.object,
        match: PropTypes.shape({
            params: PropTypes.shape({
                learningAssetId: PropTypes.string
            })
        }),
        userLearningAssetsLoading: PropTypes.bool,
        location: PropTypes.object
    };

    static contextType = RuntimeContext;

    componentDidMount() {
        const { getManyUserLearningAssets, loggedInUser, getLearningAsset, match } = this.props;

        if (loggedInUser && loggedInUser._id) {
            return getLearningAsset({
                learningAssetId: match.params.learningAssetId,
                getFullProjection: true,
                pathsContext: this.context.pathsWeb
            }).then((learningAsset) => {
                if (!learningAsset.isActive) {
                    return window.location.replace(`${this.context.pathsWeb.clientUrl}/contentretirederrorpage`);
                }
                return getManyUserLearningAssets({
                    userProfileId: loggedInUser._id,
                    pathsContext: this.context.pathsWeb
                });
            });
        }
        return null;
    }

    componentDidUpdate(prevProps = {}) {
        const { getManyUserLearningAssets, getLearningAsset, match } = this.props;

        if (
            !(prevProps.loggedInUser && prevProps.loggedInUser._id) &&
            // eslint-disable-next-line prettier/prettier
            this.props.loggedInUser &&
            this.props.loggedInUser._id
        ) {
            return getLearningAsset({
                learningAssetId: match.params.learningAssetId,
                getFullProjection: true,
                pathsContext: this.context.pathsWeb
            }).then((learningAsset) => {
                if (!learningAsset.isActive) {
                    return window.location.replace(`${this.context.pathsWeb.clientUrl}/contentretirederrorpage`);
                }
                return getManyUserLearningAssets({
                    userProfileId: this.props.loggedInUser._id,
                    pathsContext: this.context.pathsWeb
                });
            });
        }

        if (prevProps.userLearningAssetsLoading && !this.props.userLearningAssetsLoading) {
            return this._goToUserLearningAsset();
        }
        return null;
    }

    _goToUserLearningAsset = () => {
        const {
            match: {
                params: { learningAssetId }
            },
            location = {},
            postUserLearningAsset,
            userLearningAssetsByLearningAssetId,
            history,
            loggedInUser,
            userLearningAssetsLoading
        } = this.props;

        const stateParams = location.state || {};
        if (!userLearningAssetsLoading && learningAssetId in userLearningAssetsByLearningAssetId) {
            const userLearningAssetId = userLearningAssetsByLearningAssetId[learningAssetId]._id;
            history.replace({
                pathname: `/workspace/${userLearningAssetId}`,
                state: stateParams
            });
        } else if (!userLearningAssetsLoading && !userLearningAssetsByLearningAssetId[learningAssetId]) {
            const body = {
                trackId: learningAssetId,
                userProfileId: loggedInUser._id
            };
            return postUserLearningAsset({ body, pathsContext: this.context.pathsWeb }).then(
                (returnedUserLearningAsset) => {
                    const newUserLearningAssetId = returnedUserLearningAsset._id;
                    history.replace({
                        pathname: `/workspace/${newUserLearningAssetId}`,
                        state: stateParams
                    });
                }
            );
        }
        return null;
    };

    render = () => (
        <div className={'assetLinkPage'}>
            <LoadingIndicator />
        </div>
    );
}
const mapStateToProps = (state) => {
    const {
        userLearningAssets,
        auth: { loggedInUser }
    } = state;
    const availableAssets = Object.values(userLearningAssets.byId).filter(
        (asset) => asset.userProfileId === loggedInUser._id
    );
    const userLearningAssetsByLearningAssetId = keyBy(availableAssets, 'trackId');
    return {
        userLearningAssetsByLearningAssetId,
        loggedInUser,
        userLearningAssetsLoading: userLearningAssets.loading
    };
};

const mapDispatchToProps = (dispatch) => ({
    postUserLearningAsset: (params) => dispatch(postUserLearningAsset(params)),
    getManyUserLearningAssets: (params) => dispatch(getManyUserLearningAssets(params)),
    getLearningAsset: (params) => dispatch(getLearningAsset(params))
});

export const AssetLinkComponent = AssetLink;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetLink));
